import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {loadInterestConfirmed as load} from 'flows/interest/confirmed/index';

import InterestConfirmed from './component';

export class InterestConfirmedContainer extends React.Component {
  componentDidMount() {
    this.props.load();
  }
  render() {
    return (<InterestConfirmed />);
  }
}

InterestConfirmedContainer.propTypes = {
  load: PropTypes.func.isRequired,
};

export default connect(null, {load})(InterestConfirmedContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/confirmed/index.js